import { useState, useEffect } from 'react';
import { useQueryParam, StringParam } from 'use-query-params';

import { CANDIDATE_PROFILE_DRAWER_TAB_PARAM_KEY } from 'src/pages/CandidateManagementPage/queryParams';
import type { IJobApplication } from 'src/stores/JobApplicationStore/JobApplication';

import type { DetailTabSelectOption } from '../DetailsTabView';
import { getDetailTabs } from '../utils/tabUtils';

export const useGetDetailsTabs = ({
  jobApplication,
  isMobile,
  isCurrentWorkplaceFeatureEnabled,
}: {
  jobApplication: IJobApplication;
  isMobile: boolean;
  isCurrentWorkplaceFeatureEnabled: boolean;
}) => {
  const { prospectEmailStore, candidateStore, noteAttachmentCount } =
    jobApplication;

  const [tabs, setTabs] = useState<DetailTabSelectOption[]>([]);

  const [, setTabQueryParam] = useQueryParam(
    CANDIDATE_PROFILE_DRAWER_TAB_PARAM_KEY,
    StringParam,
  );

  useEffect(() => {
    const setDetailTabs = () => {
      setTabs(
        getDetailTabs({
          jobApplication,
          isMobile,
          isCurrentWorkplaceFeatureEnabled,
          setTabQueryParam,
        }),
      );
    };
    setDetailTabs();
  }, [
    jobApplication,
    isMobile,
    candidateStore.prospectCount,
    prospectEmailStore.emailCount,
    noteAttachmentCount,
    isCurrentWorkplaceFeatureEnabled,
    setTabQueryParam,
  ]);
  return tabs;
};
